import { render, staticRenderFns } from "./ListScientific_industry.vue?vue&type=template&id=1723b968&scoped=true"
import script from "./ListScientific_industry.vue?vue&type=script&lang=js"
export * from "./ListScientific_industry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723b968",
  null
  
)

export default component.exports